import { AgentLicensePlanAgentBundle } from './agent-license-plan-agent-bundle';
import { LicensePlan } from './license-plan';

export class AgentLicensePlan {
	public id: number;
	public agentId: string;
	public licensePlanId: number;
	public quantity: number;

	public licensePlan: LicensePlan;
	public agentBundles: AgentLicensePlanAgentBundle[];

	constructor(agentLicensePlan: AgentLicensePlan) {
		Object.assign(this, agentLicensePlan);

		this.licensePlan = agentLicensePlan.licensePlan ? new LicensePlan(agentLicensePlan.licensePlan) : null;
	}
}
